/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

import { HttpGetCatalogService } from "./http-get-catalog.service";
import { Catalog, Dataset, Offer } from "../../models/catalog-dto";
import { datasetToAssetDTO } from "../../models/catalog";
import { Injectable } from "@angular/core";
import { Asset } from "../../models/asset";
import { map, Observable } from "rxjs";

type AssetWithOffers = Asset & { offers: Offer[] };

@Injectable({
  	providedIn: 'root'
})

export class GetCatalogService {

	constructor(
		private httpGetCatalogService: HttpGetCatalogService
	) { }

    public obtain$(): Observable<{ 
        assets: AssetWithOffers[];
    }> {

        return this.httpGetCatalogService.obtain$().pipe(

            map((catalogs: Catalog[]) => {

                const assets = catalogs.flatMap(catalog => {

                    const connectorID = catalog['dspace:participantId'] ?? '';
                    const originator = catalog['originator'] ?? '';

                    const datasets = Array.isArray(catalog['dcat:dataset'])
                        ? catalog['dcat:dataset']
                        : [catalog['dcat:dataset'] as Dataset];

                    return datasets.map((dataset: Dataset) => {

                        const dto = datasetToAssetDTO(dataset, catalog);

                        const offers = dto.offers;

                        const asset = Asset.createFromDTO(dto);

                        asset.connector = connectorID;
                        asset.originator = originator;

                        return {
                            ...asset,
                            offers
                        };

                    });

                });

                return { assets };

            })

        );
        
    }
    
}